<div class="reports-container">
  <h1 class="reports-title">法規鑑別統計報表</h1>

  <!-- 罰鍰風險摘要卡片 -->
  <div class="risk-summary-cards">
    <div class="risk-card total-risk">
      <div class="risk-icon">
        <i class="fa-solid fa-triangle-exclamation"></i>
      </div>
      <div class="risk-details">
        <h3>總罰鍰風險</h3>
        <div class="risk-amount">{{ formatCurrency(totalPenaltyRisk) }}</div>
        <div class="risk-description">所有法規不合規可能導致的最大罰鍰總額</div>
      </div>
    </div>

    <div class="risk-card mitigated-risk">
      <div class="risk-icon">
        <i class="fa-solid fa-shield-check"></i>
      </div>
      <div class="risk-details">
        <h3>已避免風險</h3>
        <div class="risk-amount">{{ formatCurrency(mitigatedPenaltyRisk) }}</div>
        <div class="risk-progress">
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="riskMitigationPercentage"></div>
          </div>
          <div class="progress-text">{{ riskMitigationPercentage }}% 風險已降低</div>
        </div>
      </div>
    </div>

    <div class="risk-card potential-risk">
      <div class="risk-icon">
        <i class="fa-solid fa-bolt"></i>
      </div>
      <div class="risk-details">
        <h3>潛在風險</h3>
        <div class="risk-amount">{{ formatCurrency(potentialPenaltyRisk) }}</div>
        <div class="risk-description">尚未完全合規法規的潛在罰鍰總額</div>
      </div>
    </div>
  </div>

  <!-- 每月法規異動圖表 -->
  <div class="chart-container monthly-chart">
    <div #monthlyChangesChart class="chart"></div>
  </div>

  <!-- 圓餅圖區域：法規類型和部門責任 -->
  <div class="pie-charts-container">
    <!-- 法規類型分佈 -->
    <div class="chart-container">
      <div #regulationTypeChart class="chart"></div>
    </div>

    <!-- 部門責任分佈 -->
    <div class="chart-container">
      <div #departmentChart class="chart"></div>
    </div>
  </div>
</div>
